/** PROTOTYPE. The one control every variant shares: refresh or probe the target. */
import { LoaderIcon, RefreshCwIcon } from "lucide-react";

import { Button } from "../../ui/button";
import type { DiagnosticsPrototypeVariantProps } from "./diagnosticsPrototypeProps";

export function PrototypeRefreshButton({
  refresh,
}: {
  readonly refresh: DiagnosticsPrototypeVariantProps["refresh"];
}) {
  return (
    <Button
      variant="outline"
      size="sm"
      className="ml-auto"
      disabled={refresh.refreshing || !refresh.canRefresh}
      onClick={refresh.onRefresh}
    >
      {refresh.refreshing ? (
        <LoaderIcon className="size-4 animate-spin" aria-hidden="true" />
      ) : (
        <RefreshCwIcon className="size-4" aria-hidden="true" />
      )}
      {refresh.label}
    </Button>
  );
}
